import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IControl } from 'core/dynamic-form';
import { ScreenUtilsService } from 'core/services';
import { DynamicFormDialogComponent } from './dynamic-form-dialog.component';

export interface IDynamicFormDialogOptions {

  //todo
  layout?: any

  title: string

  subtitle: string

  showClearBtn?: boolean

  controls: IControl[]

  defaultBtnText?: string

}

export type DynamicFormDialogPayload = {
  dialogService: DynamicFormDialogService,
  formOptions: IDynamicFormDialogOptions
}

@Injectable({ providedIn: 'root' })
export class DynamicFormDialogService {

  _dialogRef!: MatDialogRef<DynamicFormDialogComponent, any>

  readonly screenSizeSubject = this._screenUtilsService.screenSizeSubject;
  get screenSize() {
    return this.screenSizeSubject.value;
  }

  constructor(
    private readonly _dialog: MatDialog,
    private readonly _screenUtilsService: ScreenUtilsService
  ) { }

  open<R = any>(formOptions: IDynamicFormDialogOptions) {

    const self = this;
    const dialogRef = this._dialog.open<
      DynamicFormDialogComponent,
      DynamicFormDialogPayload,
      R
    >(
      DynamicFormDialogComponent,
      {
        data: {
          dialogService: self,
          formOptions,
        },
        panelClass: !['sm', 'xs'].includes(this.screenSize) ? 'col-min-width-large' : undefined,
        minWidth: ['sm', 'xs'].includes(this.screenSize) ? '100%' : undefined,
        height: ['sm', 'xs'].includes(this.screenSize) ? '100%' : 'auto'
      },
    )

    this._dialogRef = dialogRef;

    return dialogRef.afterClosed();
  }

}
